import React from 'react';
import { Phone, Mic, Save } from 'lucide-react';
export function WorksLikeThis() {
  const steps = [{
    icon: <Phone className="w-8 h-8" data-id="element-205" />,
    title: 'Pick Up The Phone',
    description: 'Guests pick up the receiver and hear a custom greeting recorded by you.'
  }, {
    icon: <Mic className="w-8 h-8" data-id="element-206" />,
    title: 'Leave a Message',
    description: 'After the beep, they leave their message, advice, or funny story.'
  }, {
    icon: <Save className="w-8 h-8" data-id="element-207" />,
    title: 'Hang Up',
    description: "Hanging up saves the recording securely. It's that simple!"
  }];
  return <section id="how-it-works" className="bg-[#FFC4D0] py-20 px-4 md:px-8" data-id="element-208">
      <div className="container mx-auto" data-id="element-209">
        <div className="flex flex-col md:flex-row items-center gap-16" data-id="element-210">
          <div className="md:w-1/2" data-id="element-211">
            <div className="relative" data-id="element-212">
              <img src="https://images.unsplash.com/photo-1520342868574-5fa3804e551c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Guests using phone" className="rounded-3xl shadow-xl w-full object-cover aspect-[4/3] border-4 border-white" data-id="element-213" />
              <div className="absolute -bottom-6 -right-6 bg-black text-white p-4 rounded-xl shadow-lg" data-id="element-214">
                <p className="font-['Caveat'] text-2xl" data-id="element-215">So easy to use!</p>
              </div>
            </div>
          </div>

          <div className="md:w-1/2" data-id="element-216">
            <h2 className="text-5xl md:text-6xl font-bold mb-12 text-[#1a1a1a]" data-id="element-217">
              Works Like This
            </h2>

            <div className="space-y-10" data-id="element-218">
              {steps.map((step, index) => <div key={index} className="flex gap-6 group" data-id="element-219">
                  <div className="flex-shrink-0 w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#FFB5C5] shadow-md group-hover:scale-110 transition-transform duration-300" data-id="element-220">
                    {step.icon}
                  </div>
                  <div data-id="element-221">
                    <h3 className="text-2xl font-bold mb-2" data-id="element-222">{step.title}</h3>
                    <p className="text-gray-800 leading-relaxed" data-id="element-223">
                      {step.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}